import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect, useState} from "react";
import Table from "../../components/common/table/Table";
import {useDispatch, useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {getTableColumns, getTableData} from "../../models/vendorModel";
import ActionDropdown from "../../components/actions/ActionDropdown";
import {
    deleteVendor,
    fetchVendors,
    resetCreateStatus,
    resetUpdateStatus,
    resetUpdateVendorPaymentStatus
} from "../../store/vendor-slice";
import AlertMessage from "../../components/ui/AlertMessage";

const VendorView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [alertInfo, setAlertInfo] = useState(null);

    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        updateVendorPaymentStatus,
        pagination,
        error
    } = useSelector(state => state.vendor);

    const userRole = useSelector((state) => state.auth.selectedRole);

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    function calculateVendorTotals(items) {
        let totalDue = 0;
        let totalAdvanced = 0;

        items.forEach(vendor => {
            totalDue += Number(vendor.dueAmount || 0);
            totalAdvanced += Number(vendor.advancedAmount || 0);
        });

        return {
            totalDue,
            totalAdvanced
        };
    }

    const {totalDue, totalAdvanced} = calculateVendorTotals(items);

    useEffect(() => {
        dispatch(fetchVendors({...userRole, page: initialPage, limit: initialLimit}));
    }, [dispatch, initialPage, initialLimit, userRole]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    const showAlert = (message, variant = 'info') => {
        setAlertInfo({message, variant});
    };

    useEffect(() => {
        if (error) {
            showAlert(error, 'danger');
        }
    }, [error])

    useEffect(() => {
        if (updateVendorPaymentStatus === "success") {
            dispatch(resetUpdateVendorPaymentStatus());
        }
    }, [dispatch, updateVendorPaymentStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteVendor({...userRole, id})); // Ensure this action matches your Redux action for deleting users
    };

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler}); // Ensure this function is set for user data
    const tableData = getTableData({items}); // Adjust the parameters as needed based on your data structure

    return (
        <>
            <SubHeader title="All Vendors">
                <div className="d-flex align-items-center">
                    <h5 className="text-danger me-2 fs-md mb-0 border p-1 rounded-2 border-danger">Total Due:
                        ₹ {totalDue} /-</h5>
                    <h5 className="text-primary fs-md mb-0 border p-1 rounded-2 border-primary">Total Advanced:
                        ₹ {totalAdvanced}
                        /-</h5>
                </div>
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" &&
                <Table className="mobile-responsive" columns={tableColumns} data={tableData} pagination={pagination}/>}

            {/*Alert*/}
            {alertInfo && (
                <AlertMessage
                    message={alertInfo.message}
                    variant={alertInfo.variant}
                    duration={2000}
                    onClose={() => setAlertInfo(null)}
                />
            )}
        </>
    )
}

export default VendorView;